<template>
  <div>
    <li class="ticket-item">
      <p @click="onClick">
        {{ ticketItem.text ? ticketItem.text : "名称未設定のクーポンです" }}
      </p>
      <img class="chev" src="@/assets/chevron.svg" />
      <div v-show="isDialogOpen" class="background" @click="onClose"></div>
      <div v-show="isDialogOpen" class="dialog">
        <p class="description">
          クーポンをスタッフに提示して「使用する」ボタンを押してください
        </p>
        <p class="ticket-name">
          {{ ticketItem.text ? ticketItem.text : "名称未設定のクーポンです" }}
        </p>
        <div class="button" :class="{ used: isUsed }" @click="onClickUse">
          {{ isUsed ? "使用済み" : "使用する" }}
        </div>
        <div class="img-area">
          <img src="@/assets/coupon/1.png" alt="" />
        </div>
        <div class="close" @click="onClose">閉じる</div>
      </div>
    </li>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";
import Firebase from "../../firebase";

export default {
  name: "ticket-list-item",
  components: {
    ButtonTextLink,
  },
  props: {
    ticketItem: { type: Object, require: true },
    current: { type: String, default: false, required: true },
  },
  computed: {
    ...mapState(["selectedSpotTicketData", "registrationId"]),
    currentTicketData() {
      if (this.current === "RouteSearch") {
        return this.selectedSpotTicketData.dropspot;
      } else if (this.current === "MyPage") {
        return this.selectedSpotTicketData.mypage;
      } else if (this.current === "JyutaiSearch") {
        return this.selectedSpotTicketData.jyutai;
      }
    },
    formattedCurrentDate() {
      const formattedCurrentDate = this.formatDateToCalc(new Date());
      return formattedCurrentDate;
    },
    isUsed() {
      return (
        this.currentTicketData.filter((ticket) => {
          if (ticket.TicketId !== this.ticketItem.id) return false;
          if (ticket.RegistrationAutoId !== this.registrationId) return false;

          return true;
        }).length > 0
      );
    },
  },
  data() {
    return {
      isDialogOpen: false,
    };
  },
  methods: {
    ...mapMutations(["loadingStartMini", "loadingEndMini"]),
    onClick() {
      this.isDialogOpen = true;
    },
    async onClickUse() {
      if (this.isUsed) return;
      this.loadingStartMini();
      await Firebase.useTicket(this.ticketItem.id);
      this.loadingEndMini();
    },
    onClose() {
      this.isDialogOpen = false;
    },
    formatDateToCalc(dt) {
      var y = String(dt.getFullYear());
      var m = String(("00" + (dt.getMonth() + 1)).slice(-2));
      var d = String(("00" + dt.getDate()).slice(-2));

      return Number(`${y}${m}${d}`);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.ticket-item {
  margin: 0;
  display: flex;
  border-top: 1px #e7e7e7 solid;
  position: relative;
  align-items: center;
  padding: 1rem 0.5rem;
  p {
    display: inline-block;
    margin: 0;
    width: calc(100% - 1.2rem);
  }
  .chev {
    transform: rotate(-90deg);
    height: 0.5rem;
  }

  .button {
    margin: 1rem auto;
    text-align: center;
    border-radius: 4px;
    width: 100%;
    background-color: #5cd5d6;
    padding: 0.75rem 0;
    color: white;
    font-size: 1.1rem;
    font-weight: 700;
    &.used {
      background: #c3c3c3;
      color: white;
    }
  }

  .close {
    color: #5cd5d6;
    width: 100%;
    text-align: center;
  }

  .description {
    font-size: 0.7rem;
    margin-bottom: 1rem;
    width: 100%;
    text-align: center;
  }
  .ticket-name {
    font-size: 1rem;
    font-weight: bold;
    text-align: center;
    margin-bottom: 1rem;
    width: 100%;
  }

  .img-area {
    margin: 1rem 0 2rem;
    display: flex;
    justify-content: center;

    img {
      height: 20vh;
    }
  }
  .background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1000;
  }
  .dialog {
    position: fixed;
    display: flex;
    flex-direction: column;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-55%);
    background-color: white;
    z-index: 1001;
    width: 80vw;
    padding: 1rem;
    border-radius: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Tickets/ListItem.vue